export const getParameter = (name) => {
    const nvp = location.search.substr(1).split("&").find(nvp => nvp.split("=")[0] == name)
    if (nvp) {
        var value = nvp.substr(nvp.indexOf("=") + 1);
        try { return decodeURIComponent(value) }
        catch (e) { return value }
    }
    return null;
}

export const googleMapsDirectionsUrl = (poi) => (
    `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(poi.lat)},${encodeURIComponent(poi.lng)}&travelmode=driving`
)
